// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd60a3b2","644":"8b6ea055"}[chunkId] + ".chunk.js";
};